module.exports = __webpack_public_path__ + "static/media/vegitables_64.97a5c0f7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_64.csv
// module id = 651
// module chunks = 0